<template>
  <div class="card mt-2">
    <div class="card-header d-flex justify-content-between align-items-center py-2">
      <span class="font-weight-bold">{{ $t("fieldSchema.title") }}</span>
      <b-button size="sm" variant="success" @click="addField">
        + {{ $t("fieldSchema.addField") }}
      </b-button>
    </div>
    <div class="card-body p-2">
      <div
        v-for="(field, index) in value"
        :key="index"
        class="border rounded p-2 mb-2 bg-light"
      >
        <div class="form-row align-items-end">
          <div class="form-group col-md-4 mb-1">
            <label class="small mb-0">{{ $t("fieldSchema.labelLabel") }}</label>
            <input
              type="text"
              class="form-control form-control-sm"
              :value="field.label"
              :placeholder="$t('fieldSchema.labelPlaceholder')"
              @input="onLabelInput(field, $event.target.value)"
            />
          </div>
          <div class="form-group col-md-2 mb-1">
            <label class="small mb-0">{{ $t("fieldSchema.keyLabel") }}</label>
            <input
              type="text"
              class="form-control form-control-sm"
              v-model="field.key"
              @input="field.keyEdited = true"
            />
          </div>
          <div class="form-group col-md-2 mb-1">
            <label class="small mb-0">{{ $t("fieldSchema.typeLabel") }}</label>
            <select
              class="form-control form-control-sm"
              v-model="field.type"
              @change="onTypeChange(field)"
            >
              <option value="text">{{ $t("fieldSchema.typeText") }}</option>
              <option value="number">{{ $t("fieldSchema.typeNumber") }}</option>
              <option value="textarea">{{ $t("fieldSchema.typeTextarea") }}</option>
              <option value="select">{{ $t("fieldSchema.typeSelect") }}</option>
            </select>
          </div>
          <div class="form-group col-md-2 mb-1">
            <label class="small mb-0">{{ $t("fieldSchema.colLabel") }}</label>
            <select class="form-control form-control-sm" v-model="field.col">
              <option value="col-md-3">3 (25%)</option>
              <option value="col-md-4">4 (33%)</option>
              <option value="col-md-6">6 (50%)</option>
              <option value="col-md-12">12 (100%)</option>
            </select>
          </div>
          <div class="form-group col-md-2 mb-1 text-right">
            <b-button size="sm" variant="danger" @click="removeField(index)">✕</b-button>
          </div>
        </div>

        <div class="d-flex flex-wrap mt-1">
          <b-form-checkbox v-model="field.required" class="mr-3">
            {{ $t("fieldSchema.requiredLabel") }}
          </b-form-checkbox>
          <b-form-checkbox v-if="allowPrescription" v-model="field.show_in_prescription">
            {{ $t("fieldSchema.showInPrescription") }}
          </b-form-checkbox>
        </div>

        <div v-if="field.type === 'select'" class="mt-2">
          <label class="small mb-1 font-weight-bold">{{ $t("fieldSchema.optionsLabel") }}</label>
          <div
            v-for="(opt, optIndex) in field.options"
            :key="optIndex"
            class="d-flex align-items-center mb-1"
          >
            <input
              type="text"
              class="form-control form-control-sm mr-1"
              v-model="field.options[optIndex]"
              :placeholder="$t('fieldSchema.optionPlaceholder', { n: optIndex + 1 })"
            />
            <b-button size="sm" variant="outline-danger" @click="field.options.splice(optIndex, 1)">
              ✕
            </b-button>
          </div>
          <b-button size="sm" variant="outline-secondary" @click="field.options.push('')">
            + {{ $t("fieldSchema.addOption") }}
          </b-button>
        </div>
      </div>
      <p v-if="!value.length" class="text-muted small mb-0">
        {{ $t("fieldSchema.noFields") }}
      </p>
    </div>
  </div>
</template>

<script>
import { BButton, BFormCheckbox } from "bootstrap-vue";

// "Número do conselho" -> "numero_do_conselho"
function slugify(text) {
  return String(text || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .replace(/^(\d)/, "f_$1")
    .slice(0, 50);
}

export default {
  name: "FieldSchemaEditor",
  components: { BButton, BFormCheckbox },
  props: {
    // Lista de campos {key, label, type, required, col, options, show_in_prescription}
    value: { type: Array, required: true },
    allowPrescription: { type: Boolean, default: false },
  },
  methods: {
    addField() {
      this.value.push({
        key: "",
        label: "",
        type: "text",
        required: false,
        show_in_prescription: false,
        col: "col-md-6",
        options: [],
        keyEdited: false,
      });
    },

    removeField(index) {
      this.value.splice(index, 1);
    },

    // A chave acompanha o rótulo em campos novos, até alguém editá-la à mão.
    onLabelInput(field, label) {
      field.label = label;
      if (field.keyEdited === false) field.key = slugify(label);
    },

    onTypeChange(field) {
      if (field.type !== "select") field.options = [];
    },
  },
};
</script>
